export const REQUEST_API_DATA = 'REQUEST_API_DATA';
export const RECEIVE_API_DATA = 'RECEIVE_API_DATA';
export const RECEIVE_API_DATA_PROFILE = 'RECEIVE_API_DATA_PROFILE';
export const SAVE_BUSINESS_USER_DATA = 'SAVE_BUSINESS_USER_DATA';
export const RECEIVE_BUSINESS_USER_DATA = 'RECEIVE_BUSINESS_USER_DATA';
export const GET_TRANSCARD_PAYMENT_METHODS = 'GET_TRANSCARD_PAYMENT_METHODS';
export const RECIEVE_GET_TRANSCARD_PAYMENT_METHODS = 'RECIEVE_GET_TRANSCARD_PAYMENT_METHODS';
export const DISBURSE_AMOUNT = 'DISBURSE_AMOUNT';
export const RECEIVE_DISBURSE_AMOUNT = 'RECEIVE_DISBURSE_AMOUNT';
export const TRANSFER_FUNDS_TO_ACH = 'TRANSFER_FUNDS_TO_ACH';
export const TRANSFER_FUNDS_TO_CARD = 'TRANSFER_FUNDS_TO_CARD';
export const RECEIVE_TRANSFER_FUNDS_TO_ACH = 'RECEIVE_TRANSFER_FUNDS_TO_ACH';
export const RECEIVE_TRANSFER_FUNDS_TO_CARD = 'RECEIVE_TRANSFER_FUNDS_TO_CARD';
export const CLEAR_RECEIVE_ADD_USER_BANK_ACCOUNT_API = 'CLEAR_RECEIVE_ADD_USER_BANK_ACCOUNT_API';
export const CLEAR_RECEIVE_ADD_USER_CARD = 'CLEAR_RECEIVE_ADD_USER_CARD';
export const CLEAR_RECEIVE_ADD_BUSINESS_USER_CARD = 'CLEAR_RECEIVE_ADD_BUSINESS_USER_CARD';
export const SET_DEFAULT_BANK_ACCOUNT = 'SET_DEFAULT_BANK_ACCOUNT';
export const RECEIVE_SET_DEFAULT_CARD = 'RECEIVE_SET_DEFAULT_CARD';
export const SET_DEFAULT_CARD = 'SET_DEFAULT_CARD';
export const ADD_USER_CARD = 'ADD_USER_CARD';
export const RECEIVE_ADD_USER_CARD = 'RECEIVE_ADD_USER_CARD';
export const ADD_BUSINESS_USER_CARD = 'ADD_BUSINESS_USER_CARD';
export const RECEIVE_ADD_BUSINESS_USER_CARD = 'RECEIVE_ADD_BUSINESS_USER_CARD';
export const DELETE_USER_BANK_ACCOUNT = 'DELETE_USER_BANK_ACCOUNT';
export const RECEIVE_DELETE_USER_BANK_ACCOUNT = 'RECEIVE_DELETE_USER_BANK_ACCOUNT';
export const DELETE_USER_CARD = 'DELETE_USER_CARD';
export const RECEIVE_DELETE_USER_CARD = 'RECEIVE_DELETE_USER_CARD';
export const RECEIVE_SET_DEFAULT_BANK_ACCOUNT = 'RECEIVE_SET_DEFAULT_BANK_ACCOUNT';
export const SAVE_BUSINESS_USER_DATA_PARTNER =
  'SAVE_BUSINESS_USER_DATA_PARTNER';
export const RECEIVE_BUSINESS_USER_DATA_PARTNER =
  'RECEIVE_BUSINESS_USER_DATA_PARTNER';

export const SAVE_BUSINESS_USER_DATA_FIRST_STEP =
  'SAVE_BUSINESS_USER_DATA_FIRST_STEP';
export const RECEIVE_BUSINESS_USER_DATA_FIRST_STEP =
  'RECEIVE_BUSINESS_USER_DATA_FIRST_STEP';

export const CLEAR_BUSINESS_USER_DATA_FIRST_STEP =
  'CLEAR_BUSINESS_USER_DATA_FIRST_STEP';
export const RECEIVE_CLEAR_BUSINESS_USER_DATA_FIRST_STEP =
  'RECEIVE_CLEAR_BUSINESS_USER_DATA_FIRST_STEP';

export const SAVE_CONSUMER_USER_DATA = 'SAVE_CONSUMER_USER_DATA';
export const RECEIVE_CONSUMER_USER_DATA = 'RECEIVE_CONSUMER_USER_DATA';

export const GET_ALL_STATES = 'GET_ALL_STATES';
export const RECEIVE_ALL_STATES = 'RECEIVE_ALL_STATES';

// GET_ALL_VEHICLE_YEAR

export const GET_ALL_VEHICLE_YEAR = 'GET_ALL_VEHICLE_YEAR';
export const RECEIVE_ALL_VEHICLE_YEAR = 'RECEIVE_ALL_VEHICLE_YEAR';

export const GET_ALL_EXTERNAL_VEHICLE_DATA = 'GET_ALL_EXTERNAL_VEHICLE_DATA';
export const RECEIVE_ALL_EXTERNAL_VEHICLE_DATA =
  'RECEIVE_ALL_EXTERNAL_VEHICLE_DATA';
// GET_ALL_TOTAL_FUND_DATA
export const GET_ALL_TOTAL_FUND_DATA = 'GET_ALL_TOTAL_FUND_DATA';
export const RECEIVE_ALL_TOTAL_FUND_DATA = 'RECEIVE_ALL_TOTAL_FUND_DATA';

export const GET_ALL_PLANES = 'GET_ALL_PLANES';
export const RECEIVE_ALL_PLANES = 'RECEIVE_ALL_PLANES';

// GET_DETAIL_BYAFFILIATEKEY
export const GET_DETAIL_BYAFFILIATEKEY = 'GET_DETAIL_BYAFFILIATEKEY';
export const RECEIVE_DETAIL_BYAFFILIATEKEY = 'RECEIVE_DETAIL_BYAFFILIATEKEY';

export const GET_SAVE_MULTIPLE_VEHICLE_DATA = 'GET_SAVE_MULTIPLE_VEHICLE_DATA';
export const RECEIVE_SAVE_MULTIPLE_VEHICLE_DATA =
  'RECEIVE_SAVE_MULTIPLE_VEHICLE_DATA';

export const REQUEST_FORGET_PASSWORD = 'REQUEST_FORGET_PASSWORD';
export const RECEIVE_FORGET_PASSWORD_DATA = 'RECEIVE_FORGET_PASSWORD_DATA';

export const REQUEST_USER_EMAIL = 'REQUEST_USER_EMAIL';
export const RECEIVE_USER_EMAIL_DATA = 'RECEIVE_USER_EMAIL_DATA';

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const RECEIVE_REQUEST_RESET_PASSWORD = 'RECEIVE_REQUEST_RESET_PASSWORD';

export const REQUEST_BUSINESS_DATA = 'REQUEST_BUSINESS_DATA';
export const RECEIVE_BUSINESS_DATA = 'RECEIVE_BUSINESS_DATA';

export const REQUEST_INDUSTRY_DATA = 'REQUEST_INDUSTRY_DATA';
export const RECEIVE_INDUSTRY_DATA = 'RECEIVE_INDUSTRY_DATA';

export const REQUEST_CONSUMERUSER_DATA = 'REQUEST_CONSUMERUSER_DATA';
export const LINK_ACCOUNT_PROFILE_PAGE = 'LINK_ACCOUNT_PROFILE_PAGE';
export const LINK_CARD_PROFILE_PAGE = 'LINK_CARD_PROFILE_PAGE';
export const RECIEVE_LINK_CARD_PROFILE_PAGE = 'RECIEVE_LINK_CARD_PROFILE_PAGE';
export const RECIEVE_LINK_ACCOUNT_PROFILE_PAGE = 'RECIEVE_LINK_ACCOUNT_PROFILE_PAGE';
export const GET_ADDED_BANK_ACCOUNT_FOR_USER = 'GET_ADDED_BANK_ACCOUNT_FOR_USER';
export const GET_ADDED_CARDS_FOR_USER = 'GET_ADDED_CARDS_FOR_USER';
export const RECIEVE_GET_ADDED_CARDS_FOR_USER = 'RECIEVE_GET_ADDED_CARDS_FOR_USER';
export const RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER = 'RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER';
export const UPDATE_BANK_ACCOUNT_DETAILS = 'UPDATE_BANK_ACCOUNT_DETAILS';
export const RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS = 'RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS';
export const UPDATE_CARD_DETAILS = 'UPDATE_CARD_DETAILS';
export const RECEIVE_UPDATE_CARD_DETAILS = 'RECEIVE_UPDATE_CARD_DETAILS';
export const GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER = 'GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER';
export const RECIEVE_GET_ALL_BANK_ACCOUNTS_FOR_USER = 'RECIEVE_GET_ALL_BANK_ACCOUNTS_FOR_USER';
export const RECIEVE_GET_ALL_ADDED_CARDS_FOR_USER = 'RECIEVE_GET_ALL_ADDED_CARDS_FOR_USER';
export const GET_ALL_ADDED_CARDS_FOR_USER = 'GET_ALL_ADDED_CARDS_FOR_USER';
export const GET_ALL_BANK_ACCOUNTS_FOR_USER = 'GET_ALL_BANK_ACCOUNTS_FOR_USER';
export const GET_USER_TRANSACTION_HISTORY = 'GET_USER_TRANSACTION_HISTORY';
export const RECIEVE_GET_USER_TRANSACTION_HISTORY = 'RECIEVE_GET_USER_TRANSACTION_HISTORY';
export const RECIEVE_GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER = 'RECIEVE_GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER';
export const SHOW_NET_AMOUNT_TO_USER = "SHOW_NET_AMOUNT_TO_USER";
export const RECIEVE_SHOW_NET_AMOUNT_TO_USER = "RECIEVE_SHOW_NET_AMOUNT_TO_USER";
export const ADD_USER_BANK_ACCOUNT = 'ADD_USER_BANK_ACCOUNT';
export const RECIEVE_ADD_USER_BANK_ACCOUNT_PAGE = 'RECIEVE_ADD_USER_BANK_ACCOUNT_PAGE';
export const RECEIVE_CONSUMERUSER_DATA = 'RECEIVE_CONSUMERUSER_DATA';

export const REQUEST_AUTO_UPDATE_DATA = 'REQUEST_AUTO_UPDATE_DATA';
export const RECEIVE_AUTO_UPDATE_DATA = 'RECEIVE_AUTO_UPDATE_DATA';

export const REQUEST_BUSINESSUSER_DATA = 'REQUEST_BUSINESSUSER_DATA';
export const RECEIVE_BUSINESSUSER_DATA = 'RECEIVE_BUSINESSUSER_DATA';

export const REQUEST_CONSUMERUPDATE_DATA = 'REQUEST_CONSUMERUPDATE_DATA';
export const RECEIVE_CONSUMERUPDATE_DATA = 'RECEIVE_CONSUMERUPDATE_DATA';

export const REQUEST_BUSINESSUPDATE_DATA = 'REQUEST_BUSINESSUPDATE_DATA';
export const RECEIVE_BUSINESSUPDATE_DATA = 'RECEIVE_BUSINESSUPDATE_DATA';

export const REQUEST_CHILDCOMPAY_DATA = 'REQUEST_CHILDCOMPAY_DATA';
export const RECEIVE_CHILDCOMPAY_DATA = 'RECEIVE_CHILDCOMPAY_DATA';

export const REQUEST_UPLOADFILE_DATA = 'REQUEST_UPLOADFILE_DATA';
export const RECEIVE_UPLOADFILE_DATA = 'RECEIVE_UPLOADFILE_DATA';

export const QUESTION_TYPE_FILE ='QUESTION_TYPE_FILE';
export const RECEIVE_QUESTION_TYPE_FILE = 'RECEIVE_QUESTION_TYPE_FILE';

export const QUESTION_TYPE_FILE_DELETE ='QUESTION_TYPE_FILE_DELETE';
export const RECEIVE_QUESTION_TYPE_FILE_DELETE ='RECEIVE_QUESTION_TYPE_FILE_DELETE';

export const REQUEST_UPLOADFILE_DATA_DOC = 'REQUEST_UPLOADFILE_DATA_DOC';
export const RECEIVE_UPLOADFILE_DATA_DOC = 'RECEIVE_UPLOADFILE_DATA_DOC';

export const REQUEST_BUSINESSCOMPANY_DATA = 'REQUEST_BUSINESSCOMPANY_DATA';
export const RECEIVE_BUSINESSCOMPANY_DATA = 'RECEIVE_BUSINESSCOMPANY_DATA';

// REQUEST_COUNTRY_DATA

export const REQUEST_AFFILIATE_DATA = 'REQUEST_AFFILIATE_DATA';
export const RECEIVE_AFFILIATE_DATA = 'RECEIVE_AFFILIATE_DATA';

export const REQUEST_COUNTRY_DATA = 'REQUEST_COUNTRY_DATA';
export const RECEIVE_COUNTRY_DATA = 'RECEIVE_COUNTRY_DATA';

export const REQUEST_BUSINESSCOMPANY_UPDATE_DATA =
  'REQUEST_BUSINESSCOMPANY_UPDATE_DATA';
export const RECEIVE_BUSINESSCOMPANY_UPDATE_DATA =
  'RECEIVE_BUSINESSCOMPANY_UPDATE_DATA';

export const REQUEST_DELETE_BUSINESSCOMPANY_DATA =
  'REQUEST_DELETE_BUSINESSCOMPANY_DATA';
export const RECEIVE_DELETE_BUSINESSCOMPANY_DATA =
  'RECEIVE_DELETE_BUSINESSCOMPANY_DATA';

export const REQUEST_VIEW_BUSINESSCOMPANY_DATA =
  'REQUEST_VIEW_BUSINESSCOMPANY_DATA';
export const RECEIVE_VIEW_BUSINESSCOMPANY_DATA =
  'RECEIVE_VIEW_BUSINESSCOMPANY_DATA';
// REQUEST_UPDATE_AFFILIATE_DATA

export const REQUEST_UPDATE_AFFILIATE_DATA = 'REQUEST_UPDATE_AFFILIATE_DATA';
export const RECEIVE_UPDATE_AFFILIATE_DATA = 'RECEIVE_UPDATE_AFFILIATE_DATA';

export const REQUEST_CITYID_DATA = 'REQUEST_CITYID_DATA';
export const RECEIVE_CITYID_DATA = 'RECEIVE_CITYID_DATA';

export const REQUEST_STATEID_DATA = 'REQUEST_STATEID_DATA';
export const RECEIVE_STATEID_DATA = 'RECEIVE_STATEID_DATA';

export const GET_ALL_CONSUMER_PLANES = 'GET_ALL_CONSUMER_PLANES';
export const RECEIVE_ALL_CONSUMER_PLANES = 'RECEIVE_ALL_CONSUMER_PLANES';

export const REQUEST_VEHICLE_MAKE_DATA = 'REQUEST_VEHICLE_MAKE_DATA';
export const RECEIVE_VEHICLE_MAKE_DATA = 'RECEIVE_VEHICLE_MAKE_DATA';

export const REQUEST_VEHICLE_MODEL_DATA = 'REQUEST_VEHICLE_MODEL_DATA';
export const RECEIVE_VEHICLE_MODEL_DATA = 'RECEIVE_VEHICLE_MODEL_DATA';

export const REQUEST_VEHICLE_TRIM_DATA = 'REQUEST_VEHICLE_TRIM_DATA';
export const RECEIVE_VEHICLE_TRIM_DATA = 'RECEIVE_VEHICLE_TRIM_DATA';

export const CLEAR_RECEIVE_DISBURSE_AMOUNT = 'CLEAR_RECEIVE_DISBURSE_AMOUNT';
export const CLEAR_RECEIVE_TRANSFER_FUNDS_TO_ACH = 'CLEAR_RECEIVE_TRANSFER_FUNDS_TO_ACH';
export const CLEAR_RECEIVE_TRANSFER_FUNDS_TO_CARD = 'CLEAR_RECEIVE_TRANSFER_FUNDS_TO_CARD';
export const CLEAR_GET_DEBIT_WALLET_BALANCE = 'CLEAR_GET_DEBIT_WALLET_BALANCE';
export const CLEAR_RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS = 'CLEAR_RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS';
export const CLEAR_RECEIVE_UPDATE_CARD_DETAILS = 'CLEAR_RECEIVE_UPDATE_CARD_DETAILS';

export const REQUEST_VEHICLE_SAVE_DATA_CLEAR =
  'REQUEST_VEHICLE_SAVE_DATA_CLEAR';

export const REQUEST_VEHICLE_SAVE_DATA = 'REQUEST_VEHICLE_SAVE_DATA';
export const RECEIVE_VEHICLE_SAVE_DATA = 'RECEIVE_VEHICLE_SAVE_DATA';

export const REQUEST_VEHICLE_DATA_USERID_DATA =
  'REQUEST_VEHICLE_DATA_USERID_DATA';
export const RECEIVE_VEHICLE_DATA_USERID_DATA =
  'RECEIVE_VEHICLE_DATA_USERID_DATA';

// REQUEST_DELETE_VEHICLE_DATA_USERID_DATA
export const REQUEST_DELETE_VEHICLE_DATA_USERID_DATA =
  'REQUEST_DELETE_VEHICLE_DATA_USERID_DATA';
export const RECEIVE_DELETE_VEHICLE_DATA_USERID_DATA =
  'RECEIVE_DELETE_VEHICLE_DATA_USERID_DATA';

export const REQUEST_VIEW_VEHICLE_DATA_USERID_DATA =
  'REQUEST_VIEW_VEHICLE_DATA_USERID_DATA';
export const RECEIVE_VIEW_VEHICLE_DATA_USERID_DATA =
  'RECEIVE_VIEW_VEHICLE_DATA_USERID_DATA';

// REQUEST_SAVE_RESIDENCE_DATA
export const REQUEST_SAVE_RESIDENCE_DATA = 'REQUEST_SAVE_RESIDENCE_DATA';
export const RECEIVE_SAVE_RESIDENCE_DATA = 'RECEIVE_SAVE_RESIDENCE_DATA';

export const GET_CLEAR_CHANGEPASSWORD_DATA = 'GET_CLEAR_CHANGEPASSWORD_DATA';
export const REQUEST_CHANGE_PASSWORD_DATA = 'REQUEST_CHANGE_PASSWORD_DATA';
export const RECEIVE_CHANGE_PASSWORD_DATA = 'RECEIVE_CHANGE_PASSWORD_DATA';

export const GET_CLEAR_SETTLEMENTANSWER_DATA =
  'GET_CLEAR_SETTLEMENTANSWER_DATA';
//
export const GET_CLEAR_QUESTION_DATA = 'GET_CLEAR_QUESTION_DATA';
export const GET_CLEAR_ENROLLMENT_DATA = 'GET_CLEAR_ENROLLMENT_DATA';

export const REQUEST_APPLY_NEXT_QUESTION = 'REQUEST_APPLY_NEXT_QUESTION';
export const RECEIVE_APPLY_NEXT_QUESTION = 'RECEIVE_APPLY_NEXT_QUESTION';

// RECEIVE_SAVE_APPLY_NEXT_QUESTION
export const REQUEST_SAVE_APPLY_NEXT_QUESTION =
  'REQUEST_SAVE_APPLY_NEXT_QUESTION';
export const RECEIVE_SAVE_APPLY_NEXT_QUESTION =
  'RECEIVE_SAVE_APPLY_NEXT_QUESTION';

export const REQUEST_FUSEBILL_DATA = 'REQUEST_FUSEBILL_DATA';
export const RECEIVE_FUSEBILL_DATA = 'RECEIVE_FUSEBILL_DATA';

export const REQUEST_SAVE_FUSEBILL_CARD_ID = 'REQUEST_SAVE_FUSEBILL_CARD_ID';
export const RECEIVE_FUSEBILL_CARD_ID = 'RECEIVE_FUSEBILL_CARD_ID';

export const REQUEST_SAVE_FUSEBILL_PAYMENT_METHOD =
  'REQUEST_SAVE_FUSEBILL_PAYMENT_METHOD';
export const RECEIVE_FUSEBILL_PAYMENT_METHOD =
  'RECEIVE_FUSEBILL_PAYMENT_METHOD';

export const REQUEST_CREATE_FUSEBILL_CUSTOMER =
  'REQUEST_CREATE_FUSEBILL_CUSTOMER';

export const REQUEST_CHANGE_USER_PAYMENT_STATUS =
  'REQUEST_CHANGE_USER_PAYMENT_STATUS';

export const REQUEST_FUSEBILL_COUNTRIES_DATA_FOR_CARD =
  'REQUEST_FUSEBILL_COUNTRIES_DATA_FOR_CARD';
export const RECEIVE_FUSEBILL_COUNTRIES_DATA_FOR_CARD =
  'RECEIVE_FUSEBILL_COUNTRIES_DATA_FOR_CARD';

// Logout User
export const LOGOUT_USER = "LOGOUT_USER";

export const GET_CLEAR_SERVICE_DATA = "GET_CLEAR_SERVICE_DATA";
export const requestApiData = data => ({ type: REQUEST_API_DATA, data });
export const receiveApiData = data => ({ type: RECEIVE_API_DATA, data });
export const receiveProfileApiData = data => ({ type: RECEIVE_API_DATA_PROFILE, data });
export const MARK_ALL_READ_NOTIFICATIONS = "MARK_ALL_READ_NOTIFICATIONS";


export const requestFuseBillData = (data) => ({
  type: REQUEST_FUSEBILL_DATA,
  data,
});
export const receiveFuseBillData = (data) => ({
  type: RECEIVE_FUSEBILL_DATA,
  data,
});

export const requestSaveFusebillCardId = (data) => ({
  type: REQUEST_SAVE_FUSEBILL_CARD_ID,
  data,
});
export const receiveFusebillCardId = (data) => ({
  type: RECEIVE_FUSEBILL_CARD_ID,
  data,
});

export const requestSaveFusebillPaymentMethod = (data) => ({
  type: REQUEST_SAVE_FUSEBILL_PAYMENT_METHOD,
  data,
});
export const receiveFusebillPaymentMethod = (data) => ({
  type: RECEIVE_FUSEBILL_PAYMENT_METHOD,
  data,
});

export const requestCreateFusebillCustomer = (data) => ({
  type: REQUEST_CREATE_FUSEBILL_CUSTOMER,
  data,
});

export const saveConsumerUser = (data) => ({
  type: SAVE_CONSUMER_USER_DATA,
  data,
});
export const receiveSavedConsumerUser = (data) => ({
  type: RECEIVE_CONSUMER_USER_DATA,
  data,
});

export const requestFusebillCountriesDataForCard = (data) => ({
  type: REQUEST_FUSEBILL_COUNTRIES_DATA_FOR_CARD,
  data,
});
export const receiveFusebillCountriesDataForCard = (data) => ({
  type: RECEIVE_FUSEBILL_COUNTRIES_DATA_FOR_CARD,
  data,
});

export const saveBusinessUser = (data) => ({
  type: SAVE_BUSINESS_USER_DATA,
  data,
});
export const receiveSavedBusinessUser = (data) => ({
  type: RECEIVE_BUSINESS_USER_DATA,
  data,
});

export const saveBusinessUserPatner = (data) => ({
  type: SAVE_BUSINESS_USER_DATA_PARTNER,
  data,
});
export const receiveSavedBusinessUserPartner = (data) => ({
  type: RECEIVE_BUSINESS_USER_DATA_PARTNER,
  data,
});

export const saveBusinessUserStep1 = (data) => ({
  type: SAVE_BUSINESS_USER_DATA_FIRST_STEP,
  data,
});
export const receiveSavedBusinessUserStep1 = (data) => ({
  type: RECEIVE_BUSINESS_USER_DATA_FIRST_STEP,
  data,
});

export const clearSignupData = (data) => ({
  type: CLEAR_BUSINESS_USER_DATA_FIRST_STEP,
  data,
});
export const receiveClearSignupData = (data) => ({
  type: RECEIVE_CLEAR_BUSINESS_USER_DATA_FIRST_STEP,
  data,
});

export const getAllStates = () => ({ type: GET_ALL_STATES });
export const receiveAllStates = (data) => ({ type: RECEIVE_ALL_STATES, data });

export const getAllVehicleYear = () => ({ type: GET_ALL_VEHICLE_YEAR });
export const receiveAllVehicleYear = (data) => ({
  type: RECEIVE_ALL_VEHICLE_YEAR,
  data,
});

// getExternalVehicleDataById
export const getExternalVehicleDataById = (data) => ({
  type: GET_ALL_EXTERNAL_VEHICLE_DATA,
  data,
});
export const receiveExternalVehicleDataById = (data) => ({
  type: RECEIVE_ALL_EXTERNAL_VEHICLE_DATA,
  data,
});

// getTotalFundSettlement
export const getTotalFundSettlement = () => ({ type: GET_ALL_TOTAL_FUND_DATA });
export const receiveTotalFundSettlement = (data) => ({
  type: RECEIVE_ALL_TOTAL_FUND_DATA,
  data,
});

export const requestForgetPassword = (data) => ({
  type: REQUEST_FORGET_PASSWORD,
  data,
});
export const receiveForgetPasswordData = (data) => ({
  type: RECEIVE_FORGET_PASSWORD_DATA,
  data,
});

export const getAllPlans = (data) => ({ type: GET_ALL_PLANES, data });
export const receiveAllPlans = (data) => ({ type: RECEIVE_ALL_PLANES, data });
// getAffiliateDetailByAffiliateKey
export const getAffiliateDetailByAffiliateKey = (data) => ({
  type: GET_DETAIL_BYAFFILIATEKEY,
  data,
});
export const receiveAffiliateDetailByAffiliateKey = (data) => ({
  type: RECEIVE_DETAIL_BYAFFILIATEKEY,
  data,
});

// saveMultipleVehicleData
export const saveMultipleVehicleData = (data) => ({
  type: GET_SAVE_MULTIPLE_VEHICLE_DATA,
  data,
});
export const receiveMultipleVehicleData = (data) => ({
  type: RECEIVE_SAVE_MULTIPLE_VEHICLE_DATA,
  data,
});

export const getAllPlansConsumer = (data) => ({
  type: GET_ALL_CONSUMER_PLANES,
  data,
});
export const receiveAllPlansConsumer = (data) => ({
  type: RECEIVE_ALL_CONSUMER_PLANES,
  data,
});

export const confirmUserEmail = (data) => ({ type: REQUEST_USER_EMAIL, data });
export const receiveconfirmUserEmail = (data) => ({
  type: RECEIVE_USER_EMAIL_DATA,
  data,
});

export const requestResetPassword = (data) => ({
  type: REQUEST_RESET_PASSWORD,
  data,
});
export const receiveResetPassword = (data) => ({
  type: RECEIVE_REQUEST_RESET_PASSWORD,
  data,
});

export const getBusiness = (data) => ({ type: REQUEST_BUSINESS_DATA, data });
export const receiveBusiness = (data) => ({
  type: RECEIVE_BUSINESS_DATA,
  data,
});

// get Business
export const getBusinessUser = (data) => ({
  type: REQUEST_BUSINESSUSER_DATA,
  data,
});
export const receiveBusinessUser = (data) => {
  return{
    type: RECEIVE_BUSINESSUSER_DATA,
    data,
  }
};

export const REQUEST_NOTIFICATION_DATA = 'REQUEST_NOTIFICATION_DATA';
export const RECEIVE_NOTIFICATION_DATA = 'RECEIVE_NOTIFICATION_DATA';

// get Notifiction
export const getNotificationLogUnReadCountForUser = (data) => ({
  type: REQUEST_NOTIFICATION_DATA,
  data,
});
export const receiveNotificationLogUnReadCountForUser = (data) => ({
  type: RECEIVE_NOTIFICATION_DATA,
  data,
});

export const REQUEST_BUSINESSUSER_DATA_AFFI = 'REQUEST_BUSINESSUSER_DATA_AFFI';
export const RECEIVE_BUSINESSUSER_DATA_AFFI = 'RECEIVE_BUSINESSUSER_DATA_AFFI';
// get BusinessAffilate
export const getBusinessUserAffilate = (data) => ({
  type: REQUEST_BUSINESSUSER_DATA_AFFI,
  data,
});
export const receiveBusinessUserAffilate = (data) => ({
  type: RECEIVE_BUSINESSUSER_DATA_AFFI,
  data,
});

// get Consumer
export const getConsumerUser = (data) => ({
  type: REQUEST_CONSUMERUSER_DATA,
  data,
});

export const createTranscardAccount = (data) => ({
  type: LINK_ACCOUNT_PROFILE_PAGE,
  data,
});

export const createTranscardCard = (data) => ({
  type: LINK_CARD_PROFILE_PAGE,
  data,
});

export const showNetAmountToUser = (data) => {
  return{
    type: SHOW_NET_AMOUNT_TO_USER,
    data,
  }
};

export const receiveShowNetAmountToUser = (data) => ({
  type: RECIEVE_SHOW_NET_AMOUNT_TO_USER,
  data,
});

export const getAllBankAccountsForUser = (data) => ({
  type: GET_ALL_BANK_ACCOUNTS_FOR_USER,
  data,
});

export const receiveGetAllBankAccountsForUser = (data) => ({
  type: RECIEVE_GET_ALL_BANK_ACCOUNTS_FOR_USER,
  data,
});

export const getAllAddedCardsForUser = (data) => ({
  type: GET_ALL_ADDED_CARDS_FOR_USER,
  data,
});

export const receiveGetAllAddedCardsForUser = (data) => {
  return {
    type: RECIEVE_GET_ALL_ADDED_CARDS_FOR_USER,
    data,
  }

};

export const getCollectedSettlementsHistoryForUser = (data) => ({
  type: GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,
  data,
});

export const getUserTransactionsHistory = (data) => ({
  type: GET_USER_TRANSACTION_HISTORY,
  data,
});

export const receiveGetCollectedSettlementsHistoryForUser = (data) => ({
  type: RECIEVE_GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,
  data,
});

export const receiveGetUserTransactionsHistory = (data) => {
  return{
    type: RECIEVE_GET_USER_TRANSACTION_HISTORY,
    data,
  }
};


export const getAddedBankAccountsForUser = (data) => ({
  type: GET_ADDED_BANK_ACCOUNT_FOR_USER,
  data,
});

export const getAddedCardsForUser = (data) => ({
  type: GET_ADDED_CARDS_FOR_USER,
  data,
});


export const receiveGetAddedBankAccountsForUser = (data) => {
  return{
   type: RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER,
   data,
  }
 };

export const receiveGetAddedCardsForUser = (data) => {
  return{
   type: RECIEVE_GET_ADDED_CARDS_FOR_USER,
   data,
  }
 };

export const addUserBankAccount = (data) => ({
  type: ADD_USER_BANK_ACCOUNT,
  data,
});

export const updateBankAccountDetails = (data) => ({
  type: UPDATE_BANK_ACCOUNT_DETAILS,
  data
})

export const receiveUpdateBankAccountDetails = (data) => ({
  type: RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS,
  data
})

export const updateCardDetails = (data) => ({
  type: UPDATE_CARD_DETAILS,
  data
})

export const receiveUpdateCardDetails = (data) => ({
  type: RECEIVE_UPDATE_CARD_DETAILS,
  data
})

export const receiveConsumerUser = (data) => ({
  type: RECEIVE_CONSUMERUSER_DATA,
  data,
});

// updateAutoSettlementFlag
export const updateAutoSettlementFlag = (data) => ({
  type: REQUEST_AUTO_UPDATE_DATA,
  data,
});
export const receiveUpdateAutoSettlementFlag = (data) => ({
  type: RECEIVE_AUTO_UPDATE_DATA,
  data,
});

export const updateAffiliate = (data) => ({
  type: REQUEST_UPDATE_AFFILIATE_DATA,
  data,
});
export const receiveUpdateAffiliateUser = (data) => ({
  type: RECEIVE_UPDATE_AFFILIATE_DATA,
  data,
});

// getAllCountry

export const getAffiliateUser = (data) => ({
  type: REQUEST_AFFILIATE_DATA,
  data,
});

export const receiveAffiliateUser = (data) => {
  return{
    type: RECEIVE_AFFILIATE_DATA,
    data
  }
}

export const getAllCountry = (data) => ({ type: REQUEST_COUNTRY_DATA, data });
export const receiveAllCountry = (data) => ({
  type: RECEIVE_COUNTRY_DATA,
  data,
});

// getAllVehicleMake
export const getAllVehicleMake = (data) => ({
  type: REQUEST_VEHICLE_MAKE_DATA,
  data,
});
export const receiveAllVehicleMake = (data) => ({
  type: RECEIVE_VEHICLE_MAKE_DATA,
  data,
});

// get ChildCompanyProfile
export const getAllChildCompanyProfile = (data) => ({
  type: REQUEST_CHILDCOMPAY_DATA,
  data,
});
export const receiveChildCompanyProfile = (data) => ({
  type: RECEIVE_CHILDCOMPAY_DATA,
  data,
});

// getAllVehicleTrim
export const getAllVehicleTrim = (data) => ({
  type: REQUEST_VEHICLE_TRIM_DATA,
  data,
});
export const receivegetAllVehicleTrim = (data) => ({
  type: RECEIVE_VEHICLE_TRIM_DATA,
  data,
});
export const getAllVehicleModelClear = (data) => ({
  type: RECEIVE_VEHICLE_MODEL_DATA,
  data,
});
export const getAllVehicleMakeClear = (data) => ({
  type: RECEIVE_VEHICLE_MAKE_DATA,
  data,
});
export const getAllVehicleTrimClear = (data) => ({
  type: RECEIVE_VEHICLE_TRIM_DATA,
  data,
});

// getAllVehicleDataByUserId
export const getAllVehicleDataByUserId = (data) => ({
  type: REQUEST_VEHICLE_DATA_USERID_DATA,
  data,
});
export const receiveAllVehicleDataByUserId = (data) => ({
  type: RECEIVE_VEHICLE_DATA_USERID_DATA,
  data,
});

// viewVehicleEditRecord
export const viewVehicleEditRecord = (data) => ({
  type: REQUEST_VIEW_VEHICLE_DATA_USERID_DATA,
  data,
});
export const receiveViewVehicleEditRecord = (data) => ({
  type: RECEIVE_VIEW_VEHICLE_DATA_USERID_DATA,
  data,
});

// saveResidences
export const saveResidences = (data) => ({
  type: REQUEST_SAVE_RESIDENCE_DATA,
  data,
});
export const receivesaveResidences = (data) => ({
  type: RECEIVE_SAVE_RESIDENCE_DATA,
  data,
});

// deleteVehicleRecordsData
export const deleteVehicleRecordsData = (data) => ({
  type: REQUEST_DELETE_VEHICLE_DATA_USERID_DATA,
  data,
});
export const receivedeleteVehicleRecordsData = (data) => ({
  type: RECEIVE_DELETE_VEHICLE_DATA_USERID_DATA,
  data,
});

// addVehicleData
export const addVehicleData = (data) => ({
  type: REQUEST_VEHICLE_SAVE_DATA,
  data,
});
export const receiveAddVehicleData = (data) => ({
  type: RECEIVE_VEHICLE_SAVE_DATA,
  data,
});

// addVehicleData
export const clearSaveVehicleData = (data) => ({
  type: REQUEST_VEHICLE_SAVE_DATA_CLEAR,
  data,
});

// getAllVehicleModel
export const getAllVehicleModel = (data) => ({
  type: REQUEST_VEHICLE_MODEL_DATA,
  data,
});
export const receiveAllVehicleModel = (data) => ({
  type: RECEIVE_VEHICLE_MODEL_DATA,
  data,
});

// changePasswordData
export const changePasswordData = (data) => ({
  type: REQUEST_CHANGE_PASSWORD_DATA,
  data,
});
export const receiveChangePasswordData = (data) => ({
  type: RECEIVE_CHANGE_PASSWORD_DATA,
  data,
});

// clearDataChange
export const clearDataChange = (data) => ({
  type: GET_CLEAR_CHANGEPASSWORD_DATA,
  data,
});

export const clearServiceData = (data) => ({
  type: GET_CLEAR_SERVICE_DATA,
  data,
});

export const receiveChangePassword = (data) => ({
  type: RECEIVE_CHANGE_PASSWORD_DATA,
  data,
});

// moveToNextQuestionList
export const moveToNextQuestionList = (data) => ({
  type: REQUEST_APPLY_NEXT_QUESTION,
  data,
});
export const receiveMoveToNextQuestionList = (data) => ({
  type: RECEIVE_APPLY_NEXT_QUESTION,
  data,
});

// clearData
export const clearData = (data) => ({ type: GET_CLEAR_QUESTION_DATA, data });

export const clearDataEnrollment = (data) => ({
  type: GET_CLEAR_ENROLLMENT_DATA,
  data,
});

export const receiveMoveToNextQuestion = (data) => ({
  type: RECEIVE_APPLY_NEXT_QUESTION,
  data,
});
export const receiveMoveToSaveQuestion = (data) => ({
  type: RECEIVE_SAVE_APPLY_NEXT_QUESTION,
  data,
});
export const receiveClearAffilate = (data) => ({
  type: RECEIVE_DETAIL_BYAFFILIATEKEY,
  data,
});

// saveToNextQuestionList
export const saveToNextQuestionList = (data) => ({
  type: REQUEST_SAVE_APPLY_NEXT_QUESTION,
  data,
});

// clearSavedata
const dataEmaty = [];
export const clearSavedata = () => ({
  type: RECEIVE_SAVE_APPLY_NEXT_QUESTION,
  dataEmaty,
});

export const receiveSaveMoveToNextQuestionList = (data) => ({
  type: RECEIVE_SAVE_APPLY_NEXT_QUESTION,
  data,
});

export const updateConsumerUser = (data) => ({
  type: REQUEST_CONSUMERUPDATE_DATA,
  data,
});
export const receiveUpdateConsumerUser = (data) => ({
  type: RECEIVE_CONSUMERUPDATE_DATA,
  data,
});

export const receiveTranscardAccountApi = (data) => ({
  type: RECIEVE_LINK_ACCOUNT_PROFILE_PAGE,
  data,
});

export const receiveTranscardCardApi = (data) => ({
  type: RECIEVE_LINK_CARD_PROFILE_PAGE,
  data,
});

export const receiveAddUserBankAccountApi = (data) => {
 return{
  type: RECIEVE_ADD_USER_BANK_ACCOUNT_PAGE,
  data,
 }
};

export const REQUEST_DEFENDENT_AUTO_DATA = 'REQUEST_DEFENDENT_AUTO_DATA';
export const RECEIVE_DEFENDENT_AUTO_DATA = 'RECEIVE_DEFENDENT_AUTO_DATA';

export const REQUEST_SAVE_UNELIGIBLE = 'REQUEST_SAVE_UNELIGIBLE';
export const RECEIVE_SAVE_UNELIGIBLE = 'RECEIVE_SAVE_UNELIGIBLE';

// getAutoPartDefendentPartsByPartId
export const getAutoPartDefendentPartsByPartId = (data) => ({
  type: REQUEST_DEFENDENT_AUTO_DATA,
  data,
});
export const receiveAutoPartDefendentPartsByPartId = (data) => ({
  type: RECEIVE_DEFENDENT_AUTO_DATA,
  data,
});

// saveUsersUneligibleSettlements
export const saveUsersUneligibleSettlements = (data) => ({
  type: REQUEST_SAVE_UNELIGIBLE,
  data,
});
export const receiveUsersUneligibleSettlements = (data) => ({
  type: RECEIVE_SAVE_UNELIGIBLE,
  data,
});

export const updateBusinessUser = (data) => ({
  type: REQUEST_BUSINESSUPDATE_DATA,
  data,
});
export const receiveUpdateBusinessUser = (data) => ({
  type: RECEIVE_BUSINESSUPDATE_DATA,
  data,
});

export const uploadfile = (data) => ({ type: REQUEST_UPLOADFILE_DATA, data });
export const uploadEligibilityQuestionFileByUser = (data) => ({
  type: QUESTION_TYPE_FILE,
  data
});
export const deleteEligibilityQuestionFileByUser = (data) => ({
  type: QUESTION_TYPE_FILE_DELETE,
  data
});
export const receiveDeleteEligibilityQuestionFileByUser = (data) => ({
  type: RECEIVE_QUESTION_TYPE_FILE_DELETE,
  data
});
export const receieveUploadEligibilityQuestionFileByUser = (data) =>  {
 console.log("kk".data)
 return {
  type : RECEIVE_QUESTION_TYPE_FILE,
  data
  }
}
export const receiveSavedUploadFile = (data) => ({
  type: RECEIVE_UPLOADFILE_DATA,
  data,
});

export const updateUserSignatureWithDocs = (data) => ({
  type: REQUEST_UPLOADFILE_DATA_DOC,
  data,
});
export const receiveSavedUploadFileDoc = (data) => ({
  type: RECEIVE_UPLOADFILE_DATA_DOC,
  data,
});

export const getStates = (data) => ({ type: REQUEST_STATEID_DATA, data });
export const receiveGetState = (data) => ({ type: RECEIVE_STATEID_DATA, data });

export const getCityByStateId = (data) => ({ type: REQUEST_CITYID_DATA, data });
export const receiveGetCity = (data) => ({ type: RECEIVE_CITYID_DATA, data });

// getCityByStateId
export const updateBusinessCompany = (data) => ({
  type: REQUEST_BUSINESSCOMPANY_DATA,
  data,
});
export const receiveUpdateBusinessCompany = (data) => ({
  type: RECEIVE_BUSINESSCOMPANY_DATA,
  data,
});
// updateBusinessCompanyData
export const updateBusinessCompanyData = (data) => ({
  type: REQUEST_BUSINESSCOMPANY_UPDATE_DATA,
  data,
});
export const receiveUpdateBusinessCompanyData = (data) => ({
  type: RECEIVE_BUSINESSCOMPANY_UPDATE_DATA,
  data,
});

export const deleteCompanyChildRecord = (data) => ({
  type: REQUEST_DELETE_BUSINESSCOMPANY_DATA,
  data,
});
export const receiveDeleteCompanyChildRecord = (data) => ({
  type: RECEIVE_DELETE_BUSINESSCOMPANY_DATA,
  data,
});

export const viewCompanyChildRecord = (data) => ({
  type: REQUEST_VIEW_BUSINESSCOMPANY_DATA,
  data,
});
export const receiveViewCompanyChildRecord = (data) => ({
  type: RECEIVE_VIEW_BUSINESSCOMPANY_DATA,
  data,
});

export const getIndustry = (data) => ({ type: REQUEST_INDUSTRY_DATA, data });
export const receiveIndustry = (data) => ({
  type: RECEIVE_INDUSTRY_DATA,
  data,
});

export const REQUEST_SETTLEMENT_ENRICH_QUE = 'REQUEST_SETTLEMENT_ENRICH_QUE';
export const RECEIVE_SETTLEMENT_ENRICH_QUE = 'RECEIVE_SETTLEMENT_ENRICH_QUE';
export const getSettlemetEnrichmentQuestion = (data) => ({
  type: REQUEST_SETTLEMENT_ENRICH_QUE,
  data,
});
export const receiveSettlemetEnrichmentQuestion = (data) => ({
  type: RECEIVE_SETTLEMENT_ENRICH_QUE,
  data,
});

export const REQUEST_ALL_SETTLEMENT = 'REQUEST_ALL_SETTLEMENT';
export const RECEIVE_ALL_SETTLEMENT = 'RECEIVE_ALL_SETTLEMENT';
export const getAllSettlement = (data) => ({
  type: REQUEST_ALL_SETTLEMENT,
  data,
});
export const receiveAllSettlement = (data) => ({
  type: RECEIVE_ALL_SETTLEMENT,
  data,
});

// getPromotedSettlementByUserId
export const REQUEST_ALL_PROMOTED_SETTLEMENT =
  'REQUEST_ALL_PROMOTED_SETTLEMENT';
export const RECEIVE_ALL_PROMOTED_SETTLEMENT =
  'RECEIVE_ALL_PROMOTED_SETTLEMENT';
export const getPromotedSettlementByUserId = (data) => ({
  type: REQUEST_ALL_PROMOTED_SETTLEMENT,
  data,
});
export const receivePromotedSettlementByUserId = (data) => ({
  type: RECEIVE_ALL_PROMOTED_SETTLEMENT,
  data,
});

export const REQUEST_ALL_FILTEREDSETTLEMENT = 'REQUEST_ALL_FILTEREDSETTLEMENT';
export const RECEIVE_ALL_FILTEREDSETTLEMENT = 'RECEIVE_ALL_FILTEREDSETTLEMENT';
export const REQUEST_ALL_DASHBOARD_FILTEREDSETTLEMENT =
  'REQUEST_ALL_DASHBOARD_FILTEREDSETTLEMENT';
export const RECEIVE_ALL_DASHBOARD_FILTEREDSETTLEMENT =
  'RECEIVE_ALL_DASHBOARD_FILTEREDSETTLEMENT';

export const getAllFilteredSettlement = (data) => ({
  type: REQUEST_ALL_FILTEREDSETTLEMENT,
  data,
});
export const receiveAllFilteredSettlement = (data) => ({
  type: RECEIVE_ALL_FILTEREDSETTLEMENT,
  data,
});
// getAllFilteredDSettlement
export const getAllFilteredDSettlement = (data) => ({
  type: REQUEST_ALL_DASHBOARD_FILTEREDSETTLEMENT,
  data,
});
export const receiveAllDFilteredSettlement = (data) => ({
  type: RECEIVE_ALL_DASHBOARD_FILTEREDSETTLEMENT,
  data,
});

export const REQUEST_ALL_FILTEREDSETTLEMENT_AFFILIATE =
  'REQUEST_ALL_FILTEREDSETTLEMENT_AFFILIATE';
export const RECEIVE_ALL_FILTEREDSETTLEMENT_AFFILIATE =
  'RECEIVE_ALL_FILTEREDSETTLEMENT_AFFILIATE';

export const getSettlementListByAffiliateType = (data) => ({
  type: REQUEST_ALL_FILTEREDSETTLEMENT_AFFILIATE,
  data,
});
export const receiveSettlementListByAffiliateType = (data) => ({
  type: RECEIVE_ALL_FILTEREDSETTLEMENT_AFFILIATE,
  data,
});


export const GET_AFFILIATE_GROUP_SUCCESS =
  "GET_AFFILIATE_GROUP_SUCCESS";
export const RECEIVE_GET_AFFILIATE_GROUP_SUCCESS =
  "RECEIVE_GET_AFFILIATE_GROUP_SUCCESS";

export const getAffiliateGroup = data => ({
  type: GET_AFFILIATE_GROUP_SUCCESS,
  data
});
export const receiveGetAffiliateGroup = data => {
  console.log("datarex",data);
  return{
    type: RECEIVE_GET_AFFILIATE_GROUP_SUCCESS,
    data
  }
};
// getAllReferredUserByAffiliateId

export const REQUEST_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID =
  'REQUEST_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID';
export const RECEIVE_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID =
  "RECEIVE_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID";
export const GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER =
  "GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER";
export const RECEIVE_GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER =
  "RECEIVE_GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER";
export const GET_ALL_PARTNERS_BY_GROUP =
  "GET_ALL_PARTNERS_BY_GROUP";
export const GET_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER = 
  "GET_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER";
export const RECEIVE_GET_ALL_PARTNERS_BY_GROUP =
  "RECEIVE_GET_ALL_PARTNERS_BY_GROUP";  
export const RECEIVE_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER =
  "RECEIVE_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER";  

export const getAllReferredUserByAffiliateId = (data) => ({
  type: REQUEST_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID,
  data,
});
export const getAllGroupsByParentAffiliateUser = data => ({
  type: GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER,
  data
});

export const getAllPartnersByGroup = data => {
  console.log('data======', data)
  return{
  type: GET_ALL_PARTNERS_BY_GROUP,
  data
  }
};

export const receiveAllPartnerByGroup = data => {
 
  return{
    type: RECEIVE_GET_ALL_PARTNERS_BY_GROUP,
    data
  }
};

export const getAllHierarchyChildAffiliateUsersByParentAffiliateUser = data => {
  console.log('datanewget======', data)
  return{
  type: GET_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER,
  data
  }
};
export const receiveAllHierarchyChildAffiliateUsersByParentAffiliateUser = data => {
  console.log('datanew======', data)
  return{
  type: RECEIVE_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER,
  data
  }
};
export const receiveAllReferredUserByAffiliateId = data => ({
  type: RECEIVE_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID,
  data,
});

export const receiveAllGroupsByParentAffiliateUser = data => {
  return{
    type: RECEIVE_GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER,
    data
  }
};


// getEnrolledListByAffiliateId

export const REQUEST_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID =
  'REQUEST_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID';
export const RECEIVE_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID =
  "RECEIVE_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID";
export const GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP =
  "GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP";
export const RECEIVE_GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP =
  "RECEIVE_GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP";

export const getEnrolledListByAffiliateId = (data) => ({
  type: REQUEST_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID,
  data,
});
export const getEnrolledListBySearchAndFilterForGroup = data => ({
  type: GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP,
  data
});
export const receiveGetEnrolledListBySearchAndFilterForGroup = data => ({
  type: RECEIVE_GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP,
  data
});
export const receiveEnrolledListByAffiliateId = data => ({
  type: RECEIVE_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID,
  data,
});

// getEnrollForPartnerUser

export const REQUEST_ALL_ENROLLED_AFFILIATEID =
  "REQUEST_ALL_ENROLLED_AFFILIATEID";
export const GET_SETTLEMENT_LIST_FOR_GROUP =
  "GET_SETTLEMENT_LIST_FOR_GROUP";
export const RECEIVE_ALL_ENROLLED_AFFILIATEID =
  "RECEIVE_ALL_ENROLLED_AFFILIATEID";
export const RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP =
  "RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP";

export const getEnrollForPartnerUser = (data) => ({
  type: REQUEST_ALL_ENROLLED_AFFILIATEID,
  data,
});
export const getSettlementListForGroup = data => ({
  type: GET_SETTLEMENT_LIST_FOR_GROUP,
  data
});
export const receiveGetSettlementListForGroup = data => ({
  type: RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP,
  data
});
export const receiveEnrollForPartnerUser = data => ({
  type: RECEIVE_ALL_ENROLLED_AFFILIATEID,
  data,
});

export const partnerUserDetail = (data) => ({
  type: RECEIVE_ALL_ENROLLED_AFFILIATEID,
  data,
});

// clearBarGraphDataForDashboard

export const clearBarGraphDataForDashboard = (data) => ({
  type: RECEIVE_BAR_DASHBOARD_DATA,
  data,
});

// getAllSettlementListOfUserById

export const REQUEST_ALL_USER_SETTLEMENT_AFFILIATEID =
  "REQUEST_ALL_USER_SETTLEMENT_AFFILIATEID";
export const REQUEST_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP =
  "REQUEST_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP";
export const RECEIVE_ALL_USER_SETTLEMENT_AFFILIATEID =
  "RECEIVE_ALL_USER_SETTLEMENT_AFFILIATEID";
export const RECEIVE_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP =
  "RECEIVE_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP";
export const GET_SETTLEMENT_DETAIL_FOR_GROUP =
  "GET_SETTLEMENT_DETAIL_FOR_GROUP";
export const RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP =
  "RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP";

export const getAllSettlementListOfUserById = (data) => ({
  type: REQUEST_ALL_USER_SETTLEMENT_AFFILIATEID,
  data,
});
export const getAllSettlementListOfUserByIdForGroup = data => ({
  type: REQUEST_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP,
  data
});

export const getSettlementDetailForGroup = data => ({
  type: GET_SETTLEMENT_DETAIL_FOR_GROUP,
  data
});


export const receiveGetSettlementDetailForGroup = data => ({
  type: RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP,
  data
});
export const receiveAllSettlementListOfUserById = data => ({
  type: RECEIVE_ALL_USER_SETTLEMENT_AFFILIATEID,
  data,
});
export const receiveAllSettlementListOfUserByIdForGroup = data => {
  return{
  type: RECEIVE_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP,
  data
  }
};

export const REQUEST_ALL_ENROLLEDSETTLEMENT = 'REQUEST_ALL_ENROLLEDSETTLEMENT';
export const RECEIVE_ALL_ENROLLEDSETTLEMENT = 'RECEIVE_ALL_ENROLLEDSETTLEMENT';
export const getAllEnrolledSettlement = (data) => ({
  type: REQUEST_ALL_ENROLLEDSETTLEMENT,
  data,
});
export const receiveAllEnrolledSettlement = (data) => ({
  type: RECEIVE_ALL_ENROLLEDSETTLEMENT,
  data,
});

export const REQUEST_ALL_CATEGORY = 'REQUEST_ALL_CATEGORY';
export const RECEIVE_ALL_CATEGORY = 'RECEIVE_ALL_CATEGORY';
export const getAllCategory = (data) => ({ type: REQUEST_ALL_CATEGORY, data });
export const receiveAllCategory = (data) => ({
  type: RECEIVE_ALL_CATEGORY,
  data,
});

export const REQUEST_SETTLEMENT_FOR_USER = 'REQUEST_SETTLEMENT_FOR_USER';
export const RECEIVE_SETTLEMENT_FOR_USER = 'RECEIVE_SETTLEMENT_FOR_USER';
export const getEnrollSettlementForUser = (data) => ({
  type: REQUEST_SETTLEMENT_FOR_USER,
  data,
});
export const receiveEnrollSettlementForUser = (data) => ({
  type: RECEIVE_SETTLEMENT_FOR_USER,
  data,
});

export const REQUEST_ALL_FEATURE_SETTLEMENT = 'REQUEST_ALL_FEATURE_SETTLEMENT';
export const RECEIVE_ALL_FEATURE_SETTLEMENT = 'RECEIVE_ALL_FEATURE_SETTLEMENT';
export const getAlLFeatureSettlement = (data) => ({
  type: REQUEST_ALL_FEATURE_SETTLEMENT,
  data,
});
export const receiveAlLFeatureSettlement = (data) => ({
  type: RECEIVE_ALL_FEATURE_SETTLEMENT,
  data,
});

export const REQUEST_ALL_ATTENTION_SETTLEMENT =
  'REQUEST_ALL_ATTENTION_SETTLEMENT';
export const RECEIVE_ALL_ATTENTION_SETTLEMENT =
  'RECEIVE_ALL_ATTENTION_SETTLEMENT';
export const REQUEST_ALL_COMPLETE_SETTLEMENT = 
  'REQUEST_ALL_COMPLETE_SETTLEMENT';
export const RECEIVE_ALL_COMPLETE_SETTLEMENT = 
  'RECEIVE_ALL_COMPLETE_SETTLEMENT';
export const getAttentionSettlementForUser = (data) => ({
  type: REQUEST_ALL_ATTENTION_SETTLEMENT,
  data,
});
export const receiveAttentionSettlementForUser = (data) => ({
  type: RECEIVE_ALL_ATTENTION_SETTLEMENT,
  data,
});
export const getCompleteSettlementForUser = (data) => ({
  type: REQUEST_ALL_COMPLETE_SETTLEMENT,
  data,
});
export const receiveCompleteSettlementForUser = (data) => ({
  type: RECEIVE_ALL_COMPLETE_SETTLEMENT,
  data,
});

export const SAVE_ENRICHMENT_QUESTION = 'SAVE_ENRICHMENT_QUESTION';
export const RECEIVE_SAVE_ENRICHMENT_QUESTION =
  'RECEIVE_SAVE_ENRICHMENT_QUESTION';
export const saveEnrichmentAnswer = (data) => ({
  type: SAVE_ENRICHMENT_QUESTION,
  data,
});
export const receiveEnrichmentAnswer = (data) => ({
  type: RECEIVE_SAVE_ENRICHMENT_QUESTION,
  data,
});

// getAllSitePages
export const GET_ALL_SITE = 'GET_ALL_SITE';
export const RECEIVE_ALL_SITE = 'RECEIVE_ALL_SITE';
export const getAllSitePages = (data) => ({ type: GET_ALL_SITE, data });
export const receiveAllSitePages = (data) => ({ type: RECEIVE_ALL_SITE, data });

export const GET_COGNITO_ID_BY_EMAIL = 'GET_COGNITO_ID_BY_EMAIL';
export const RECEIVE_COGNITO_ID_BY_EMAIL = 'RECEIVE_COGNITO_ID_BY_EMAIL';
export const getCognitoIdByEmail = (data) => ({
  type: GET_COGNITO_ID_BY_EMAIL,
  data,
});
export const receiveCognitoIdByEmail = (data) => ({
  type: RECEIVE_COGNITO_ID_BY_EMAIL,
  data,
});

export const REQUEST_CONFIRM_EMAIL_COGNITO = 'REQUEST_CONFIRM_EMAIL_COGNITO';
export const RECEIVE_CONFIRM_EMAIL_COGNITO = 'RECEIVE_CONFIRM_EMAIL_COGNITO';
export const confirmCognitoUserEmail = (data) => ({
  type: REQUEST_CONFIRM_EMAIL_COGNITO,
  data,
});
export const receiveconfirmCognitoUserEmail = (data) => ({
  type: RECEIVE_CONFIRM_EMAIL_COGNITO,
  data,
});

export const GET_SETTLEMENT_QUESTION_ID = 'GET_SETTLEMENT_QUESTION_ID';
export const RECEIVE_SETTLEMENT_QUESTION_ID = 'RECEIVE_SETTLEMENT_QUESTION_ID';
export const getSettlementById = (data) => ({
  type: GET_SETTLEMENT_QUESTION_ID,
  data,
});
export const receiveGetSettlementById = (data) => ({
  type: RECEIVE_SETTLEMENT_QUESTION_ID,
  data,
});

export const REQUEST_AFFILIATESUBUSER_DATA = 'REQUEST_AFFILIATESUBUSER_DATA';
export const RECEIVE_AFFILIATESUBUSER_DATA = 'RECEIVE_AFFILIATESUBUSER_DATA';
export const submitSubUser = (data) => ({
  type: REQUEST_AFFILIATESUBUSER_DATA,
  data,
});
export const receiveAffiliateSubUser = (data) => ({
  type: RECEIVE_AFFILIATESUBUSER_DATA,
  data,
});

export const submitSubUserClear = () => ({
  type: RECEIVE_AFFILIATESUBUSER_DATA,
  data: [],
});

export const REQUEST_BUSINESSSUBUSER_DATA = 'REQUEST_BUSINESSSUBUSER_DATA';
export const RECEIVE_BUSINESSSUBUSER_DATA = 'RECEIVE_BUSINESSSUBUSER_DATA';
export const RECEIVE_CLEAR_BUSINESSSUBUSER_DATA =
  'RECEIVE_CLEAR_BUSINESSSUBUSER_DATA';
export const submitSubUserBusiness = (data) => ({
  type: REQUEST_BUSINESSSUBUSER_DATA,
  data,
});
export const receiveBusinessSubUser = (data) => ({
  type: RECEIVE_BUSINESSSUBUSER_DATA,
  data,
});
export const clearBusinessSubUser = (data) => ({
  type: RECEIVE_CLEAR_BUSINESSSUBUSER_DATA,
  data,
});

export const REQUEST_AFFILIATESUBUSERLIST_DATA =
  'REQUEST_AFFILIATESUBUSERLIST_DATA';
export const RECEIVE_AFFILIATESUBUSERLIST_DATA =
  'RECEIVE_AFFILIATESUBUSERLIST_DATA';
export const getAllAffiliatedUsers = (data) => ({
  type: REQUEST_AFFILIATESUBUSERLIST_DATA,
  data,
});
export const receiveAllAffiliatedUsers = (data) => ({
  type: RECEIVE_AFFILIATESUBUSERLIST_DATA,
  data,
});

export const REQUEST_BUSINESSSUBUSERLIST_DATA =
  'REQUEST_BUSINESSSUBUSERLIST_DATA';
export const RECEIVE_BUSINESSSUBUSERLIST_DATA =
  'RECEIVE_BUSINESSSUBUSERLIST_DATA';
export const getAllBusinessSubUsers = (data) => ({
  type: REQUEST_BUSINESSSUBUSERLIST_DATA,
  data,
});
export const receiveAllBusinessSubUsers = (data) => ({
  type: RECEIVE_BUSINESSSUBUSERLIST_DATA,
  data,
});

export const REQUEST_DELETE_AFFILIATESUBUSER_DATA =
  'REQUEST_DELETE_AFFILIATESUBUSER_DATA';
export const RECEIVE_DELETE_AFFILIATESUBUSER_DATA =
  'RECEIVE_DELETE_AFFILIATESUBUSER_DATA';
export const deleteAffiliatedSubUser = (data) => ({
  type: REQUEST_DELETE_AFFILIATESUBUSER_DATA,
  data,
});
export const receiveDeleteAffiliatedSubUser = (data) => ({
  type: RECEIVE_DELETE_AFFILIATESUBUSER_DATA,
  data,
});

export const REQUEST_DELETE_BUSINESSSUBUSER_DATA =
  'REQUEST_DELETE_BUSINESSSUBUSER_DATA';
export const RECEIVE_DELETE_BUSINESSSUBUSER_DATA =
  'RECEIVE_DELETE_BUSINESSSUBUSER_DATA';
export const deleteBusinessSubUser = (data) => ({
  type: REQUEST_DELETE_BUSINESSSUBUSER_DATA,
  data,
});
export const receiveDeleteBusinessSubUser = (data) => ({
  type: RECEIVE_DELETE_BUSINESSSUBUSER_DATA,
  data,
});

// export const deleteCompanyChildRecord=(data) => ({ type: REQUEST_DELETE_BUSINESSCOMPANY_DATA, data });
// export const receiveDeleteCompanyChildRecord = data => ({ type: RECEIVE_DELETE_BUSINESSCOMPANY_DATA, data });

export const SAVE_SETTLEMENT_ANSWERS = 'SAVE_SETTLEMENT_ANSWERS';
export const RECEIVE_SETTLEMENT_ANSWERS = 'RECEIVE_SETTLEMENT_ANSWERS';
export const saveSettlementAnswers = (data) => ({
  type: SAVE_SETTLEMENT_ANSWERS,
  data,
});
export const receiveSettlementAnswers = (data) => ({
  type: RECEIVE_SETTLEMENT_ANSWERS,
  data,
});

export const clearDataSettlmentanswers = (data) => ({
  type: GET_CLEAR_SETTLEMENTANSWER_DATA,
  data,
});
export const receiveDataSettlmentanswers = (data) => ({
  type: RECEIVE_SETTLEMENT_ANSWERS,
  data,
});

export const SAVE_ENROLMENT_DOC = 'SAVE_ENROLMENT_DOC';
export const RECEIVE_ENROLMENT_DOC = 'RECEIVE_ENROLMENT_DOC';
export const saveEnrollmenttDoc = (data) => ({
  type: SAVE_ENROLMENT_DOC,
  data,
});
export const receiveEnrollmenttDoc = (data) => ({
  type: RECEIVE_ENROLMENT_DOC,
  data,
});

export const UPDATE_ENROLMENT_DOC = 'UPDATE_ENROLMENT_DOC';
export const RECEIVE_UPDATE_ENROLMENT_DOC = 'RECEIVE_UPDATE_ENROLMENT_DOC';
export const updateEnrollmenttDoc = (data) => ({
  type: UPDATE_ENROLMENT_DOC,
  data,
});
export const receiveUpdateEnrollmenttDoc = (data) => ({
  type: RECEIVE_UPDATE_ENROLMENT_DOC,
  data,
});

export const CHECK_EMAIL_VERIFY = 'CHECK_EMAIL_VERIFY';
export const CLEAR_EMAIL_DATA = 'CLEAR_EMAIL_DATA';

export const RECEIVE_EMAIL_VERIFY = 'RECEIVE_EMAIL_VERIFY';
export const checkEmailVerify = (data) => ({ type: CHECK_EMAIL_VERIFY, data });
export const receivecheckEmailVerify = (data) => ({
  type: RECEIVE_EMAIL_VERIFY,
  data,
});

// clearDataEmail
export const clearDataEmail = (data) => ({ type: CLEAR_EMAIL_DATA, data });
export const receivecheckEmailVerifyData = (data) => ({
  type: RECEIVE_EMAIL_VERIFY,
  data,
});

export const CLEAR_CONSUMER_LOGIN_DATA = 'CLEAR_CONSUMER_LOGIN_DATA';

// RecieveConsumerUserDataClear
export const RecieveConsumerUserDataClear = (data) => ({
  type: CLEAR_CONSUMER_LOGIN_DATA,
  data,
});
export const RecieveConsumerUserDataClearData = (data) => ({
  type: RECEIVE_CONSUMER_USER_DATA,
  data,
});

export const CLEAR_BUSINESS_LOGIN_DATA = 'CLEAR_BUSINESS_LOGIN_DATA';

// RecieveBussnessUserDataClear
export const RecieveBussnessUserDataClear = (data) => ({
  type: CLEAR_BUSINESS_LOGIN_DATA,
  data,
});
export const RecieveBussnessUserDataClearData = (data) => ({
  type: RECEIVE_BUSINESS_USER_DATA,
  data,
});

export const SAVE_ENROLMENT_AUTH = 'SAVE_ENROLMENT_AUTH';
export const RECEIVE_ENROLMENT_AUTH = 'RECEIVE_ENROLMENT_AUTH';
export const saveEnrollmentAuthorization = (data) => ({
  type: SAVE_ENROLMENT_AUTH,
  data,
});
export const receiveEnrollmentAuthorization = (data) => ({
  type: RECEIVE_ENROLMENT_AUTH,
  data,
});

export const GET_AFFILIATE_USER_TYPE = 'GET_AFFILIATE_USER_TYPE';
export const RECEIVE_AFFILIATE_USER_TYPE = 'RECEIVE_AFFILIATE_USER_TYPE';
export const getAffiliateUserType = (data) => ({
  type: GET_AFFILIATE_USER_TYPE,
  data,
});
export const receiveAffiliateUserType = (data) => ({
  type: RECEIVE_AFFILIATE_USER_TYPE,
  data,
});

export const GET_SUBUSERBYID_TYPE = 'GET_SUBUSERBYID_TYPE';
export const RECEIVE_SUBUSERBYID_TYPE = 'RECEIVE_SUBUSERBYID_TYPE';
export const getAffiliateSubUserById = (data) => ({
  type: GET_SUBUSERBYID_TYPE,
  data,
});
export const receiveAffiliateSubUserById = (data) => ({
  type: RECEIVE_SUBUSERBYID_TYPE,
  data,
});

export const GET_BUSINESSSUBUSERBYID_TYPE = 'GET_BUSINESSSUBUSERBYID_TYPE';
export const RECEIVE_BUSINESSSUBUSERBYID_TYPE =
  'RECEIVE_BUSINESSSUBUSERBYID_TYPE';
export const getBusinessSubUserById = (data) => ({
  type: GET_BUSINESSSUBUSERBYID_TYPE,
  data,
});
export const receiveBusinessSubUserById = (data) => ({
  type: RECEIVE_BUSINESSSUBUSERBYID_TYPE,
  data,
});

export const GET_UPDATEAFFILIATESUBUSER_TYPE =
  'GET_UPDATEAFFILIATESUBUSER_TYPE';
export const RECEIVE_UPDATEAFFILIATESUBUSER_TYPE =
  'RECEIVE_UPDATEAFFILIATESUBUSER_TYPE';
export const UpdateAffiliateSubUser = (data) => ({
  type: GET_UPDATEAFFILIATESUBUSER_TYPE,
  data,
});
export const receiveUpdateAffiliateSubUser = (data) => ({
  type: RECEIVE_UPDATEAFFILIATESUBUSER_TYPE,
  data,
});

export const receiveUpdateAffiliateSubUserClear = () => ({
  type: RECEIVE_UPDATEAFFILIATESUBUSER_TYPE,
  data: [],
});

export const GET_UPDATEBUSINESSSUBUSER_TYPE = 'GET_UPDATEBUSINESSSUBUSER_TYPE';
export const RECEIVE_UPDATEBUSINESSSUBUSER_TYPE =
  'RECEIVE_UPDATEBUSINESSSUBUSER_TYPE';
export const UpdateBusinessSubUser = (data) => ({
  type: GET_UPDATEBUSINESSSUBUSER_TYPE,
  data,
});
export const receiveUpdateBusinessSubUser = (data) => ({
  type: RECEIVE_UPDATEBUSINESSSUBUSER_TYPE,
  data,
});

export const GET_COMPLETED_SETTLEMENTS = 'GET_COMPLETED_SETTLEMENTS';
export const RECEIVE_COMPLETED_SETTLEMENTS = 'RECEIVE_COMPLETED_SETTLEMENTS';
export const getCompletedSettlements = (data) => ({
  type: GET_COMPLETED_SETTLEMENTS,
  data,
});
export const receiveCompletedSettlements = (data) => ({
  type: RECEIVE_COMPLETED_SETTLEMENTS,
  data,
});

export const GET_CONSUMER_RESIDENCE = 'GET_CONSUMER_RESIDENCE';
export const RECEIVE_CONSUMER_RESIDENCE = 'RECEIVE_CONSUMER_RESIDENCE';
export const getConsumerUserResidenceAction = (data) => ({
  type: GET_CONSUMER_RESIDENCE,
  data,
});
export const receiveConsumerResidence = (data) => ({
  type: RECEIVE_CONSUMER_RESIDENCE,
  data,
});

export const DELETE_CONSUMER_RESIDENCE = 'DELETE_CONSUMER_RESIDENCE';
export const RECEIVE_DELETE_CONSUMER_RESIDENCE =
  'RECEIVE_DELETE_CONSUMER_RESIDENCE';
export const deleteResidencesData = (data) => ({
  type: DELETE_CONSUMER_RESIDENCE,
  data,
});
export const receivedeleteConsumerResidence = (data) => ({
  type: RECEIVE_DELETE_CONSUMER_RESIDENCE,
  data,
});

// viewResidencesData

export const VIEW_CONSUMER_RESIDENCE = 'VIEW_CONSUMER_RESIDENCE';
export const RECEIVE_VIEW_CONSUMER_RESIDENCE =
  'RECEIVE_VIEW_CONSUMER_RESIDENCE';
export const viewResidencesData = (data) => ({
  type: VIEW_CONSUMER_RESIDENCE,
  data,
});
export const receiveviewConsumerResidence = (data) => ({
  type: RECEIVE_VIEW_CONSUMER_RESIDENCE,
  data,
});

export const GET_PENDING_DOCS = 'GET_PENDING_DOCS';
export const RECEIVE_PENDING_DOCS = 'RECEIVE_PENDING_DOCS';
export const getPendingRequiredDoc = (data) => ({
  type: GET_PENDING_DOCS,
  data,
});
export const receivePendingRequiredDoc = (data) => ({
  type: RECEIVE_PENDING_DOCS,
  data,
});

export const GET_PENDING_DOCS_USER = 'GET_PENDING_DOCS_USER';
export const RECEIVE_PENDING_DOCS_USER = 'RECEIVE_PENDING_DOCS_USER';
export const getPendingRequiredDocUser = (data) => ({
  type: GET_PENDING_DOCS_USER,
  data,
});
export const receivePendingRequiredDocUser = (data) => ({
  type: RECEIVE_PENDING_DOCS_USER,
  data,
});

//getPendingRequiredDocUser
export const GET_PENDING_DOCS_USER_DELETE = 'GET_PENDING_DOCS_USER_DELETE';
export const RECEIVE_PENDING_DOCS_USER_DELETE =
  'RECEIVE_PENDING_DOCS_USER_DELETE';
export const getPendingRequiredDocUserDelete = (data) => ({
  type: GET_PENDING_DOCS_USER_DELETE,
  data,
});
export const receivePendingRequiredDocUserDelete = (data) => ({
  type: RECEIVE_PENDING_DOCS_USER_DELETE,
  data,
});

// getActivityLog
export const GET_ACTIVITY_LOG = 'GET_ACTIVITY_LOG';
export const RECEIVE_ACTIVITY_LOG = 'RECEIVE_ACTIVITY_LOG';
export const getActivityLog = (data) => ({ type: GET_ACTIVITY_LOG, data });
export const receiveActivityLog = (data) => ({
  type: RECEIVE_ACTIVITY_LOG,
  data,
});

export const GET_ALL_VEHICLE_DATA = 'GET_ALL_VEHICLE_DATA';
export const RECEIVE_ALL_VEHICLE_DATA = 'RECEIVE_ALL_VEHICLE_DATA';
export const getAllVehicleDataByUserIdAPI = (data) => ({
  type: GET_ALL_VEHICLE_DATA,
  data,
});
export const receiveAllVehicleDataByUserIdAPI = (data) => ({
  type: RECEIVE_ALL_VEHICLE_DATA,
  data,
});

export const GET_ALL_VEHICLE_DATA_SETTLEMENT =
  'GET_ALL_VEHICLE_DATA_SETTLEMENT';
export const RECEIVE_ALL_VEHICLE_DATA_SETTLEMENT =
  'RECEIVE_ALL_VEHICLE_DATA_SETTLEMENT';
export const getAllVehicleDataSettlementByUserIdAPI = (data) => ({
  type: GET_ALL_VEHICLE_DATA_SETTLEMENT,
  data,
});
export const receiveAllVehicleDataSettlementByUserIdAPI = (data) => ({
  type: RECEIVE_ALL_VEHICLE_DATA_SETTLEMENT,
  data,
});

// Save multiple vehicle

export const SAVE_MULTIPLE_VEHICLE_QUESTION_DATA =
  'SAVE_MULTIPLE_VEHICLE_QUESTION_DATA';
export const RECEIVE_SAVE_MULTIPLE_VEHICLE_QUESTION_DATA =
  'RECEIVE_SAVE_MULTIPLE_VEHICLE_QUESTION_DATA';
export const saveMultipleVehicleDataByUserIdAPI = (data) => ({
  type: SAVE_MULTIPLE_VEHICLE_QUESTION_DATA,
  data,
});
export const receivesaveMultipleVehicleDataByUserIdAPI = (data) => ({
  type: RECEIVE_SAVE_MULTIPLE_VEHICLE_QUESTION_DATA,
  data,
});

// getEligibilityQuestionById
export const GET_ALL_ELIGIBILITY_BACK = 'GET_ALL_ELIGIBILITY_BACK';
export const RECEIVE_ALL_ELIGIBILITY_BACK = 'RECEIVE_ALL_ELIGIBILITY_BACK';
export const getEligibilityQuestionById = (data) => ({
  type: GET_ALL_ELIGIBILITY_BACK,
  data,
});
export const receiveEligibilityQuestionById = (data) => ({
  type: RECEIVE_ALL_ELIGIBILITY_BACK,
  data,
});

export const GET_PENDING_SETTLEMENT_QUESTION_ID =
  'GET_PENDING_SETTLEMENT_QUESTION_ID';
export const RECEIVE_PENDING_SETTLEMENT_QUESTION_ID =
  'RECEIVE_PENDING_SETTLEMENT_QUESTION_ID';
export const getPendingSettlementQuestions = (data) => ({
  type: GET_PENDING_SETTLEMENT_QUESTION_ID,
  data,
});
export const receivePendingSettlementQuestions = (data) => ({
  type: RECEIVE_PENDING_SETTLEMENT_QUESTION_ID,
  data,
});

export const REQUEST_DISMISS_SETTLEMENT = 'REQUEST_DISMISS_SETTLEMENT';
export const RECEIVE_DISMISS_SETTLEMENT = 'RECEIVE_DISMISS_SETTLEMENT';
export const requestDismissSettlement = (data) => ({
  type: REQUEST_DISMISS_SETTLEMENT,
  data,
});
export const receiveDismissSettlement = (data) => ({
  type: RECEIVE_DISMISS_SETTLEMENT,
  data,
});
export const requestDismissSettlementResponse = (data) => ({
  type: REQUEST_DISMISS_SETTLEMENT,
  data,
});

export const GET_FAQ_CATEGORY = 'GET_FAQ_CATEGORY';
export const RECEIVE_FAQ_CATEGORY = 'RECEIVE_FAQ_CATEGORY';
export const getFaqCategory = (data) => ({ type: GET_FAQ_CATEGORY, data });
export const receiveFaqCategory = (data) => ({
  type: RECEIVE_FAQ_CATEGORY,
  data,
});

export const GET_All_FAQ_QUESTIONS_BY_CATEGORY_ID =
  'GET_All_FAQ_QUESTIONS_BY_CATEGORY_ID';
export const RECEIVE_FAQ_QUESTIONS_BY_CATEGORY_ID =
  'RECEIVE_FAQ_QUESTIONS_BY_CATEGORY_ID';
export const getAllFaqQuestionBYCategoryId = (data) => ({
  type: GET_All_FAQ_QUESTIONS_BY_CATEGORY_ID,
  data,
});
export const receiveFaqQuestionBYCategoryId = (data) => ({
  type: RECEIVE_FAQ_QUESTIONS_BY_CATEGORY_ID,
  data,
});

export const GET_PAGE_DATA = 'GET_PAGE_DATA';
export const RECEIVE_PAGE_DATA = 'RECEIVE_PAGE_DATA';
export const getPageData = (data) => ({ type: GET_PAGE_DATA, data });
export const receivePageData = (data) => ({ type: RECEIVE_PAGE_DATA, data });

export const GET_PAGE_DATA_FOOTER = 'GET_PAGE_DATA_FOOTER';
export const RECEIVE_PAGE_DATA_FOOTER = 'RECEIVE_PAGE_DATA_FOOTER';
export const getPageDataFooter = (data) => ({
  type: GET_PAGE_DATA_FOOTER,
  data,
});
export const receivePageDataFooter = (data) => ({
  type: RECEIVE_PAGE_DATA_FOOTER,
  data,
});

export const GET_PAGE_DATA_IDENTITY_KEY = 'GET_PAGE_DATA_IDENTITY_KEY';
export const RECEIVE_PAGE_DATA_IDENTITY_KEY = 'RECEIVE_PAGE_DATA_IDENTITY_KEY';
export const getUserByIdentityKey = (data) => ({
  type: GET_PAGE_DATA_IDENTITY_KEY,
  data,
});
export const receiveUserByIdentityKey = (data) => ({
  type: RECEIVE_PAGE_DATA_IDENTITY_KEY,
  data,
});

export const GET_ACCEPT_DOCUMENT = 'GET_ACCEPT_DOCUMENT';
export const RECEIVE_ACCEPT_DOCUMENT = 'RECEIVE_ACCEPT_DOCUMENT';
export const handleAcceptedService = (data) => ({
  type: GET_ACCEPT_DOCUMENT,
  data,
});
export const receiveAcceptDocumentUpdateByAdmin = (data) => ({
  type: RECEIVE_ACCEPT_DOCUMENT,
  data,
});

export const GET_AFFILIATE_DASHBOARD_DATA = 'GET_AFFILIATE_DASHBOARD_DATA';
export const RECEIVE_AFFILIATE_DASHBOARD_DATA =
  'RECEIVE_AFFILIATE_DASHBOARD_DATA';
export const getAffiliateDashboardUserAction = (data) => ({
  type: GET_AFFILIATE_DASHBOARD_DATA,
  data,
});
export const receiveAffiliateDashboardUserAction = (data) => ({
  type: RECEIVE_AFFILIATE_DASHBOARD_DATA,
  data,
});

export const GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT = "GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT";
export const RECEIVE_GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT =
  "RECEIVE_GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT";
  export const getAffiliateDashboardUserForParent = data => ({
    type: GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT,
    data
  });
export const receiveGetAffiliateDashboardUserForParent = data => ({
  type: RECEIVE_GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT,
  data
});
// getBarGraphDataForDashboard

export const GET_PIE_DASHBOARD_DATA = 'GET_PIE_DASHBOARD_DATA';
export const RECEIVE_PIE_DASHBOARD_DATA = 'RECEIVE_PIE_DASHBOARD_DATA';
export const getPieChartDataForDashboard = (data) => ({
  type: GET_PIE_DASHBOARD_DATA,
  data,
});
export const receivePieChartDataForDashboard = (data) => ({
  type: RECEIVE_PIE_DASHBOARD_DATA,
  data,
});

export const GET_PIE_DASHBOARD_STATE_DATA = 'GET_PIE_DASHBOARD_STATE_DATA';
export const RECEIVE_PIE_DASHBOARD_STATE_DATA =
  'RECEIVE_PIE_DASHBOARD_STATE_DATA';
export const getPieChartDataForStateDashboard = (data) => ({
  type: GET_PIE_DASHBOARD_STATE_DATA,
  data,
});
export const receivePieChartDataForStateDashboard = (data) => ({
  type: RECEIVE_PIE_DASHBOARD_STATE_DATA,
  data,
});

//
export const GET_BAR_DASHBOARD_DATA = 'GET_BAR_DASHBOARD_DATA';
export const RECEIVE_BAR_DASHBOARD_DATA = 'RECEIVE_BAR_DASHBOARD_DATA';
export const getBarGraphDataForDashboard = (data) => ({
  type: GET_BAR_DASHBOARD_DATA,
  data,
});
export const receiveBarGraphDataForDashboard = (data) => ({
  type: RECEIVE_BAR_DASHBOARD_DATA,
  data,
});

export const GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER = "GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER";
export const RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER = "RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER";
export const GET_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP = "GET_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP";
export const RECEIVE_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP = "RECEIVE_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP"; 

export const getBarGraphDataForDashboardWithSettlementIdForParentUser = data => ({
  type: GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER,
  data
});
export const receiveGetBarGraphDataForDashboardWithSettlementIdForParentUser = data => ({
  type: RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER,
  data
});
export const getMonthlyEnrollmentsByAffiliateGroup = data => ({
  type: GET_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP,
  data
});
export const receiveMonthlyEnrollmentsByAffiliateGroup = data => ({
  type: RECEIVE_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP,
  data
});
export const GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP = "GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP";
export const RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP = "RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP";
export const getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup = data => ({
  type: GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP,
  data
});
export const receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroup = data => ({
  type: RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP,
  data
});

export const PLAN_PRICE_CHANGE = "PLAN_PRICE_CHANGE";
export const PLAN_PRICE_CHANGE_CLEAR = "PLAN_PRICE_CHANGE_CLEAR";
export const RECEIVE_PLAN_PRICE_CHANGE = "RECEIVE_PLAN_PRICE_CHANGE";
export const planPriceChange = data => ({ type: PLAN_PRICE_CHANGE, data });

export const clearPlanData = () => ({ type: PLAN_PRICE_CHANGE_CLEAR });

export const receivePlanPriceChange = (data) => ({
  type: RECEIVE_PLAN_PRICE_CHANGE,
  data,
});

export const GET_DISMISS_SETTLEMENT_FOR_USER =
  'GET_DISMISS_SETTLEMENT_FOR_USER';
export const RECEIVE_DISMISS_SETTLEMENT_FOR_USER =
  'RECEIVE_DISMISS_SETTLEMENT_FOR_USER';
export const getDismissSettlementForUser = (data) => ({
  type: GET_DISMISS_SETTLEMENT_FOR_USER,
  data,
});
export const receiveDismissSettlementForUser = (data) => ({
  type: RECEIVE_DISMISS_SETTLEMENT_FOR_USER,
  data,
});

export const SAVE_SETTLEMENT_WITHOUT_DATA = 'SAVE_SETTLEMENT_WITHOUT_DATA';
export const RECEIVE_SETTLEMENT_WITHOUT_DATA =
  'RECEIVE_SETTLEMENT_WITHOUT_DATA';
export const saveSettlementWithoutData = (data) => ({
  type: SAVE_SETTLEMENT_WITHOUT_DATA,
  data,
});
export const receiveSettlementWithoutData = (data) => ({
  type: RECEIVE_SETTLEMENT_WITHOUT_DATA,
  data,
});
export const GET_REGISTRATION_LINKS_FOR_USER =
  'GET_REGISTRATION_LINKS_FOR_USER';
export const RECEIVE_REGISTRATION_LINKS_FOR_USER =
  'RECEIVE_REGISTRATION_LINKS_FOR_USER';
export const getAllAffiliateLinkAction = (data) => ({
  type: GET_REGISTRATION_LINKS_FOR_USER,
  data,
});
export const receiveAllAffiliateLinkAction = (data) => ({
  type: RECEIVE_REGISTRATION_LINKS_FOR_USER,
  data,
});
export const SUCCESS = 'SUCCESS';
export const receiveSuccess = (data) => ({ type: SUCCESS, data });

/**
 * Notification Action
 */
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const RECIEVE_ALL_NOTIFICATIONS = "RECIEVE_ALL_NOTIFICATIONS";
export const GET_MARK_NOTIFICATIONS = "GET_MARK_NOTIFICATIONS";
export const RECIEVE_MARK_NOTIFICATIONS = "RECIEVE_MARK_NOTIFICATIONS";

export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCESS";
export const MARK_NOTIFICATION_SUCCESS = "MARK_NOTIFICATION_SUCCESS";
export const TUTORIAL_POPUP_STATE_ACTION_2 = "TUTORIAL_POPUP_STATE_ACTION_2";
export const TUTORIAL_POPUP_STATE_ACTION_3 = "TUTORIAL_POPUP_STATE_ACTION_3";
export const TUTORIAL_POPUP_STATE_ACTION_4 = "TUTORIAL_POPUP_STATE_ACTION_4";
export const TUTORIAL_POPUP_STATE_ACTION_5 = "TUTORIAL_POPUP_STATE_ACTION_5";
export const TUTORIAL_POPUP_STATE_ACTION = "TUTORIAL_POPUP_STATE_ACTION";
export const CLEAR_TUTORIAL_POPUP_STATE_ACTION = "CLEAR_TUTORIAL_POPUP_STATE_ACTION";
export const CLEAR_TUTORIAL_POPUP_STATE_ACTION_2 = "CLEAR_TUTORIAL_POPUP_STATE_ACTION_2";
export const CLEAR_TUTORIAL_POPUP_STATE_ACTION_3 = "CLEAR_TUTORIAL_POPUP_STATE_ACTION_3";
export const CLEAR_TUTORIAL_POPUP_STATE_ACTION_4 = "CLEAR_TUTORIAL_POPUP_STATE_ACTION_4";
export const CLEAR_TUTORIAL_POPUP_STATE_ACTION_5 = "CLEAR_TUTORIAL_POPUP_STATE_ACTION_5";
export const getAllNotifications = data => ({
  type: GET_ALL_NOTIFICATIONS,
  data,
});
export const recieveAllNotifications = (data) => ({
  type: RECIEVE_ALL_NOTIFICATIONS,
  data,
});
export const removeNotification = (data) => {
  return{
    type: DELETE_NOTIFICATION,
    data
  }
}
export const deleteNotificationSuccess = (data) => {
  return{
    type: DELETE_NOTIFICATION_SUCCESS,
    data
  }
}
export const markAllReadNotification = (data) => {
  return{
    type: MARK_ALL_READ_NOTIFICATIONS,
    data
  }
}
export const markNotificationSuccess = (data) => {
  return{
    type: MARK_NOTIFICATION_SUCCESS,
    data
  }
}
export const tutorialPopupStateAction2 = (data) => {
  return{
    type: TUTORIAL_POPUP_STATE_ACTION_2,
    data
  }
}
export const tutorialPopupStateAction3 = (data) => {
  return{
    type: TUTORIAL_POPUP_STATE_ACTION_3,
    data
  }
}
export const tutorialPopupStateAction = (data) => {
  return{
    type: TUTORIAL_POPUP_STATE_ACTION,
    data
  }
}
export const clearTutorialPopupStateAction2 = (data) => {
  return{
    type: CLEAR_TUTORIAL_POPUP_STATE_ACTION_2,
    data
  }
}
export const clearTutorialPopupStateAction3 = (data) => {
  return{
    type: CLEAR_TUTORIAL_POPUP_STATE_ACTION_3,
    data
  }
}
export const clearTutorialPopupStateAction4 = (data) => {
  return{
    type: CLEAR_TUTORIAL_POPUP_STATE_ACTION_4,
    data
  }
}
export const clearTutorialPopupStateAction5 = (data) => {
  return{
    type: CLEAR_TUTORIAL_POPUP_STATE_ACTION_5,
    data
  }
}
export const clearTutorialPopupStateAction = (data) => {
  return{
    type: CLEAR_TUTORIAL_POPUP_STATE_ACTION,
    data
  }
}
export const tutorialPopupStateAction4 = (data) => {
  return{
    type: TUTORIAL_POPUP_STATE_ACTION_4,
    data
  }
}
export const tutorialPopupStateAction5 = (data) => {
  return{
    type: TUTORIAL_POPUP_STATE_ACTION_5,
    data
  }
}
// export const removeNotification = data => ({ type: DELETE_NOTIFICATION, data });
// export const deleteNotificationSuccess = (data) => ({
//   type: DELETE_NOTIFICATION_SUCCESS, data
// });

export const markNotificationReadForUser = (data) => ({
  type: GET_MARK_NOTIFICATIONS,
  data,
});
export const recievemarkNotificationReadForUser = (data) => ({
  type: RECIEVE_MARK_NOTIFICATIONS,
  data,
});

/**
 * Logout User
 */
export const logoutUser = () => ({ type: LOGOUT_USER });

/**
 * Upload CSV File
 */

export const POST_UPLOADED_CHILD_COMPANY = 'POST_UPLOADED_CHILD_COMPANY';
export const RECIEVE_UPLOADED_CHILD_COMPANY = 'RECIEVE_UPLOADED_CHILD_COMPANY';
export const postUploadChildCompany = (data) => ({
  type: POST_UPLOADED_CHILD_COMPANY,
  data,
});
export const receiveUploadedChildComapny = (data) => ({
  type: RECIEVE_UPLOADED_CHILD_COMPANY,
  data,
});

/**
 * Get Dashboard Record
 */
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const RECEIVE_DASHBOARD_DATA = 'RECEIVE_DASHBOARD_DATA';
export const getAllDashboard = (data) => ({ type: GET_DASHBOARD_DATA, data });
export const receiveAllDashboard = (data) => ({
  type: RECEIVE_DASHBOARD_DATA,
  data,
});

/**
 * Get Dashboard Count
 */
export const GET_DASHBOARD_DATA_COUNT = 'GET_DASHBOARD_DATA_COUNT';
export const RECEIVE_DASHBOARD_DATA_COUNT = 'RECEIVE_DASHBOARD_DATA_COUNT';
export const getUserDashboardSettlementsCounts = (data) => ({
  type: GET_DASHBOARD_DATA_COUNT,
  data,
});
export const receiveAllDashboardCount = (data) => ({
  type: RECEIVE_DASHBOARD_DATA_COUNT,
  data,
});

/**
 * Get Affiliate sers
 */
export const GET_AFFILIATE_USER_TYPE_SIGNUP = 'GET_AFFILIATE_USER_TYPE_SIGNUP';
export const RECEIVE_AFFILIATE_USER_TYPE_SIGNUP =
  'RECEIVE_AFFILIATE_USER_TYPE_SIGNUP';
export const GetAllAffiliateUsersByAffiliateType = (data) => ({
  type: GET_AFFILIATE_USER_TYPE_SIGNUP,
  data,
});
export const receiveAllAffiliateUsersByAffiliateType = (data) => ({
  type: RECEIVE_AFFILIATE_USER_TYPE_SIGNUP,
  data,
});

/**
 * Get Affiliate Resource
 */
export const GET_AFFILIATE_RESOURCE = 'GET_AFFILIATE_RESOURCE';
export const RECEIVE_AFFILIATE_RESOURCE = 'RECEIVE_AFFILIATE_RESOURCE';
export const getResourceSectionsAndLinks = (data) => ({
  type: GET_AFFILIATE_RESOURCE,
  data,
});
export const receivetResourceSectionsAndLinks = (data) => ({
  type: RECEIVE_AFFILIATE_RESOURCE,
  data,
});

export const SET_PAGE_NAME = 'SET_PAGE_NAME';
/**
 * Get Transactions History
 */
export const GET_TRANSACTIONS_HISTORY = 'GET_TRANSACTIONS_HISTORY';
export const RECEIVE_TRANSACTIONS_HISTORY = 'RECEIVE_TRANSACTIONS_HISTORY';
export const receivetUserTransactionsHistory = (data) => ({
  type: RECEIVE_TRANSACTIONS_HISTORY,
  data,
});


/**
 * Debit Wallet Balance
 */
export const GET_DEBIT_WALLET_BALANCE = 'GET_DEBIT_WALLET_BALANCE';
export const RECEIVE_DEBIT_WALLET_BALANCE = 'RECEIVE_DEBIT_WALLET_BALANCE';
export const getDebitWalletBalance = (data) => {
  return{
    type: GET_DEBIT_WALLET_BALANCE,
    data,
  }

};
export const receivetDebitWalletBalance = (data) => ({
  type: RECEIVE_DEBIT_WALLET_BALANCE,
  data,
});

export const setPageName = (data) => ({
  type: SET_PAGE_NAME,
  data,
});

/**
 * Get Transcard Payment Method
 */

 export const getTranscardPaymentMethods = () => ({
   type: GET_TRANSCARD_PAYMENT_METHODS,
 })

 export const receiveAllPaymentMethods = (data) => {
    return{
      type: RECIEVE_GET_TRANSCARD_PAYMENT_METHODS,
      data,
    }
 }

 /**
  * Disburse Amount
  */

  export const disbursePayment = (data) => {
    return{
      type: DISBURSE_AMOUNT,
      data
    }
  }

  export const receiveDisbursePayment = (data) => {
    return{
      type: RECEIVE_DISBURSE_AMOUNT,
      data
    }
  }

  export const clearRecieveDisburseAmount = () => {
    return {
      type: CLEAR_RECEIVE_DISBURSE_AMOUNT
    }
  }

  export const clearReceiveTransferFundsToACH = () => {
    return {
      type: CLEAR_RECEIVE_TRANSFER_FUNDS_TO_ACH
    }
  }

  export const clearReceiveTransferFundsToCard = () => {
    return {
      type: CLEAR_RECEIVE_TRANSFER_FUNDS_TO_CARD
    }
  }

  export const cleargetDebitWalletBalance = () => {
    return {
      type: CLEAR_GET_DEBIT_WALLET_BALANCE
    }
  }

  /**
   * Transfer funds to ACH
   */
  export const transferFundsToACH = (data) => {
    return{
      type: TRANSFER_FUNDS_TO_ACH,
      data
    }
  }
  export const receiveTransferFundsToACH = (data) => {
    return{
      type: RECEIVE_TRANSFER_FUNDS_TO_ACH,
      data
    }
  }

  /**
   * Transfer funds to Card
   */
  export const transferFundsToCard = (data) => {
    return{
      type: TRANSFER_FUNDS_TO_CARD,
      data
    }
  }
  export const receiveTransferFundsToCard = (data) => {
    return{
      type: RECEIVE_TRANSFER_FUNDS_TO_CARD,
      data
    }
  }

  export const clearReceiveAddUserBankAccountApi = () => {
    return{
      type: CLEAR_RECEIVE_ADD_USER_BANK_ACCOUNT_API
    }
  }

  export const clearReceiveAddUserCard = () => {
    return{
      type: CLEAR_RECEIVE_ADD_USER_CARD
    }
  }

  export const clearReceiveAddBusinessUserCard = () => {
    return{
      type: CLEAR_RECEIVE_ADD_BUSINESS_USER_CARD
    }
  }

  export const clearReceiveUpdateBankAccountDetails = () => {
    return{
      type: CLEAR_RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS
    }
  }

  export const clearReceiveUpdateCardDetails = () => {
      return{
        type: CLEAR_RECEIVE_UPDATE_CARD_DETAILS
      }
    }

  export const addUserCard = (data) => {
    return{
      type: ADD_USER_CARD,
      data
    }
  }

  export const receiveAddUserCard = (data) => {
    return{
      type: RECEIVE_ADD_USER_CARD,
      data
    }
  }

  export const addBusinessUserCard = (data) => {
    return{
      type: ADD_BUSINESS_USER_CARD,
      data
    }
  }

  export const receiveAddBusinessUserCard = (data) => {
    return{
      type: RECEIVE_ADD_BUSINESS_USER_CARD,
      data
    }
  }

  export const setDefaultBankAccount = (data) => {
    return{
      type: SET_DEFAULT_BANK_ACCOUNT,
      data
    }
  }

  export const setDefaultCard = (data) => {
    return{
      type: SET_DEFAULT_CARD,
      data
    }
  }

  export const receiveSetDefaultBankAccount = (data) => {
    return{
      type: RECEIVE_SET_DEFAULT_BANK_ACCOUNT,
      data
    }
  }

  export const receiveSetDefaultCard = (data) => {
    return{
      type: RECEIVE_SET_DEFAULT_CARD,
      data
    }
  }

  export const deleteUserBankAccount = (data) => {
    return{
      type: DELETE_USER_BANK_ACCOUNT,
      data
    }
  }

  export const receiveDeleteUserBankAccount = (data) => {
    return{
      type: RECEIVE_DELETE_USER_BANK_ACCOUNT,
      data
    }
  }

  export const deleteUserCard = (data) => {
    return{
      type: DELETE_USER_CARD,
      data
    }
  }

  export const receiveDeleteUserCard = (data) => {
    return{
      type: RECEIVE_DELETE_USER_CARD,
      data
    }
  }


